// @flow

const sraDocumentsInfo = {
  title: 'SRA Document Information',
  component: 'company/CompanySraDocumentsInfoModal',
  requireRowId: true,
  buttons: {
    cancel: {
      label: 'Cancel'
    },
    submit: {
      label: 'Save',
      icon: 'Done',
      uploadType: 'risk_assessment' // to UploadPresignedURL API
    },
    other: [
      {
        icon: 'Download',
        label: 'Download',
        key: 'attachment_link',
        type: 'download'
      }
    ]
  },
  initialState: null
};

export default sraDocumentsInfo;
